import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MainPage} from "./MainReportPage"
//import "./Physical-Assessment.css";
import "./PEARLIReports.css"
import React, { useRef, useEffect  } from 'react'

export const PEARLIReports = () => {
  return (
    <div className="report-dashboard">
      <link href='https://fonts.googleapis.com/css?family=Inter' rel='stylesheet'/>
      <div className="maincontentarea">
        <MainPage />
      </div>
    </div>
  );
};



/*
export function PEARLIReports() {    
    return <div className="PEARLIDisplay">
      <Chart scores={[2.5,5.0,2.3,4.65,4.3,1.2]} />
      </div>
  } 

*/
